module.exports = __webpack_public_path__ + "img/case3.c6c9a457.jpg";